import { ExerciseType } from "./types";
import { EditorInterface } from "./EditorInterface";
import { MultipleChoiceInfo } from "./MultipleChoiceInfo";
import { FillInTheBlanksInfo } from "./FillInTheBlanksInfo";
import { DragAndDropInfo } from "./DragAndDropInfo";
import { VideoInfo } from "./VideoInfo";
import { ComprehensionQuestionInfo } from "./ComprehensionQuestionInfo";
import { PronunciationPracticeInfo } from "./PronunciationPracticeInfo";
import { AudioRecordingInfo } from "./AudioRecordingInfo";
import { SpeakTheSentenceInfo } from "./SpeakTheSentenceInfo";
import { WriteTheTranslationInfo } from "./WriteTheTranslationInfo";
import { FillInTheTextInfo } from "./FillInTheTextInfo";
import { WatchVideoInfo } from "./WatchVideoInfo";
import { FormattedTextEditor } from "./FormattedTextEditor";
import { StyledSectionEditor } from "./StyledSectionEditor";
import { GlossaryInfo } from "./GlossaryInfo";

// Mapeamento de tipos de exercício para suas classes de informação de card
export const EDITORS_MAP: Record<string, typeof EditorInterface> = {
  // Implementações unificadas
  [ExerciseType.MultipleChoice]: MultipleChoiceInfo,
  [ExerciseType.FillInTheBlanks]: FillInTheBlanksInfo,
  [ExerciseType.DragAndDrop]: DragAndDropInfo,
  [ExerciseType.Video]: VideoInfo,
  [ExerciseType.ComprehensionQuestion]: ComprehensionQuestionInfo,
  [ExerciseType.PronunciationPractice]: PronunciationPracticeInfo,
  [ExerciseType.AudioRecording]: AudioRecordingInfo,
  [ExerciseType.SpeakTheSentence]: SpeakTheSentenceInfo,
  [ExerciseType.WriteTheTranslation]: WriteTheTranslationInfo,
  [ExerciseType.FillInTheText]: FillInTheTextInfo,
  [ExerciseType.WatchVideo]: WatchVideoInfo,
  [ExerciseType.WatchLargeVideo]: WatchVideoInfo,
  [ExerciseType.FormattedText]: FormattedTextEditor,
  [ExerciseType.StyledSection]: StyledSectionEditor,
  [ExerciseType.GlossaryDisplay]: GlossaryInfo,
};

/**
 * Função unificada para obter o editor apropriado para qualquer tipo de exercício
 */
export function getEditorForType(type: ExerciseType | string): typeof EditorInterface {
  // Verificar se o tipo existe diretamente no mapeamento
  if (type in EDITORS_MAP) {
    return EDITORS_MAP[type];
  }
  
  // Verificar se algum editor suporta este tipo através do método SupportsExerciseType
  for (const editorType in EDITORS_MAP) {
    const editor = EDITORS_MAP[editorType];
    if (editor.SupportsExerciseType && editor.SupportsExerciseType(type)) {
      return editor;
    }
  }
  
  // Retornar o editor base se nenhum editor específico for encontrado
  console.warn(`Editor não encontrado para o tipo: ${type}`);
  return EditorInterface;
}